
import {
  TOGGLE_SOURCE_INTEGRATION_SETTING_MAP_ACCORDION,
  RENDER_SOURCE_INTEGRATION_SETTING_MAP_ACCORDION,
  CLEAR_SOURCE_INTEGRATION_SETTING_MAP_ACCORDIONS
} from 'actions'

const initialState = {
}

export default function (state = initialState, { type, payload = {} }) {
  const accordions = { ...state }
  // payload can be any type, includ null (https://github.com/acdlite/flux-standard-action#payload)
  // here, if payload === null, this reducer throws
  if (payload === null) return state
  const { name } = payload
  switch (type) {
    case TOGGLE_SOURCE_INTEGRATION_SETTING_MAP_ACCORDION:
      accordions[name] = toggleAccordionState(accordions[name])
      return accordions
    case RENDER_SOURCE_INTEGRATION_SETTING_MAP_ACCORDION:
      return renderAccordions(accordions)
    case CLEAR_SOURCE_INTEGRATION_SETTING_MAP_ACCORDIONS:
      return initialState
    default:
      return state
  }
}

/**
 * toggleAccordionState - shift accordion state based on previous state
 *
 * @param  {string} value - current state of accordion
 * @return {string}       - new state of accordion
 */
export function toggleAccordionState (value) {
  if (value === 'loading' || value === 'rendered') {
    return 'collapsed'
  }
  return 'loading'
}

/**
 * renderAccordions - iterate over accordions and change 'loading' to 'rendered'
 *
 * @param  {object} accordions - copy of all accordion states
 * @return {object}            - updated copy of all accordion states
 */
export function renderAccordions (accordions) {
  const accordionsKeys = Object.keys(accordions)
  for (let i = 0; i < accordionsKeys.length; i++) {
    accordions[accordionsKeys[i]] = renderIfLoading(accordions[accordionsKeys[i]])
  }
  return accordions
}

/**
 * renderIfLoading - toggle to 'rendered' if 'loading'
 *
 * @param  {string} value - accordion state
 * @return {string}       - adjusted accordion state
 */
export function renderIfLoading (value) {
  if (value === 'loading') {
    return 'rendered'
  }
  return value
}



// WEBPACK FOOTER //
// ./reducers/application/workspaces-sources-integrations/accordions.js